// Define types for the configuration objects
interface ValidationRule {
  minLength?: number;
  pattern?: RegExp;
}

interface ValidationRules {
  [key: string]: ValidationRule;
}

// Validation rules object
export const VALIDATION_RULES: ValidationRules = {
  name: {
    minLength: 1,
    pattern: /^[a-zA-Z\s]*$/,
  },
  surname: {
    minLength: 1,
    pattern: /^[a-zA-Z\s]*$/,
  },
  email: {
    // FIXME: Consider using a more robust email validation pattern like:
    // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    // This follows RFC 5322 more closely and handles:
    // - Special characters in local part
    // - Multiple subdomains
    // - Domain length restrictions
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  phone: {
    pattern: /^\+?[\d\s-]{10,}$/,
  },
  address: {
    minLength: 3,
  },
  birthdate: {
    minLength: 3,
  },
  default: {
    minLength: 1,
    pattern: /^[a-zA-Z0-9\s]*$/,
  },
};
